import { Button, Grid, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import RejectCommendModal from './RejectCommendModal';
import { clearCustomerId } from '../../../ReduxStore/Slices/Operator/customerSlice';
import { clearTableGetId } from '../../../ReduxStore/Slices/TableId/TableIdGetSlice';
import { toast } from 'react-toastify';
import FullPageLoader from '../../FullPageLoader/FullPageLoader';

const ModalApproveButton = ({ values, approveStatus, onClose, sectionNameForApproveAndReject }) => {
    const roleName = sessionStorage.getItem("role")
    const { getPermissionsForAuthUser } = useSelector((state) => state?.getPermissionsForAuthUser);
    const [isRejectCommendModalopen, setRejectCommendModalopen] = useState(false);
    const dispatch = useDispatch()
    const handleRejectCommendOpenModal = () => {
        setRejectCommendModalopen(true);
    };
    const TableId = useSelector((state) => state.Table.TableId);
    const [loading, setLoading] = useState(false);


    const handleRejectCommendCloseModal = () => {
        setRejectCommendModalopen(false);
        dispatch(clearTableGetId(null))
        dispatch(clearCustomerId(null))

    };

    const { approveHomeSection } = useSelector((state) => state?.approveHomeSection);
    console.log(sectionNameForApproveAndReject, "sectionNameForApproveAndReject")
    const contentApprove = async (id) => {
        setLoading(true)

        console.log(id, "customerRegisterApprovecustomerRegisterApprove");
        if (TableId) {
            if (sectionNameForApproveAndReject === "HomeSection") {
                const data1 = {
                    data: {},
                    method: "put",
                    apiName: `approveHomeSection/${TableId}`
                };
                const approveContentResponse = await dispatch(actions.APPROVEHOMESECTION(data1));

                console.log(approveContentResponse.payload.message, "approveCustomerResponse");

                if (approveContentResponse.payload.message === "Home section approved successfully. Previous approved section deactivated.") {

                    // toast.success("Home section approved successfully. Previous approved section deactivated.")
                    // setTimeout(() => onClose(), 1500)
                    // dispatch(clearTableGetId(null))
                    // dispatch(clearCustomerId(null))


                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.success("Home section approved successfully. Previous approved section deactivated.")
                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.error(approveContentResponse.payload.message)

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                }
            } else if (sectionNameForApproveAndReject === "StakeNowSection") {
                const data1 = {
                    data: {},
                    method: "put",
                    apiName: `approveStakeNowSection/${TableId}`
                };
                const approveContentResponse = await dispatch(actions.APPROVALSTAKENOWSECTION(data1));

                console.log(approveContentResponse.payload.message, "approveCustomerResponse");

                if (approveContentResponse.payload.message === "Stake Now section approved successfully. Previous approved section deactivated.") {

                    // toast.success("Stake Now section approved successfully. Previous approved section deactivated.")
                    // setTimeout(() => onClose(), 1500)
                    // dispatch(clearTableGetId(null))
                    // dispatch(clearCustomerId(null))

                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.success("Stake Now section approved successfully. Previous approved section deactivated.")
                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.error(approveContentResponse.payload.message)

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                }
            }
            else if (sectionNameForApproveAndReject === "RefreralsSection") {
                const data1 = {
                    data: {},
                    method: "put",
                    apiName: `approveReferralSection/${TableId}`
                };
                const approveContentResponse = await dispatch(actions.APPROVEREFERRALSECTION(data1));

                console.log(approveContentResponse.payload.message, "approveCustomerResponse");

                if (approveContentResponse.payload.message === "Referral Section approved successfully. Previous approved section deactivated.") {

                    // toast.success("Referral section approved successfully. Previous approved section deactivated.")
                    // setTimeout(() => onClose(), 1500)
                    // dispatch(clearTableGetId(null))
                    // dispatch(clearCustomerId(null))

                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.success("Referral section approved successfully. Previous approved section deactivated.")

                        // toast.success("Stake Now section approved successfully. Previous approved section deactivated.")
                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.error(approveContentResponse.payload.message)

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                }
            }
            else if (sectionNameForApproveAndReject === "AboutUsSection") {
                const data1 = {
                    data: {},
                    method: "put",
                    apiName: `approveAboutUsSection/${TableId}`
                };
                const approveContentResponse = await dispatch(actions.APPROVEABOUTUSSECTION(data1));

                console.log(approveContentResponse.payload.message, "approveCustomerResponse");

                if (approveContentResponse.payload.message === "About Us section approved successfully. Previous approved section deactivated.") {

                    // toast.success("Referral section approved successfully. Previous approved section deactivated.")
                    // setTimeout(() => onClose(), 1500)
                    // dispatch(clearTableGetId(null))
                    // dispatch(clearCustomerId(null))

                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.success("About Us section approved successfully. Previous approved section deactivated.")

                        // toast.success("Stake Now section approved successfully. Previous approved section deactivated.")
                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.error(approveContentResponse.payload.message)

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                }
            }
            else if (sectionNameForApproveAndReject === "BlogSection") {
                const data1 = {
                    data: {},
                    method: "put",
                    apiName: `approveBlogSection/${TableId}`
                };
                const approveContentResponse = await dispatch(actions.APPROVEBLOGSECTION(data1));

                console.log(approveContentResponse.payload.message, "approveCustomerResponse");

                if (approveContentResponse.payload.message === "Blog section approved successfully. Previous approved section deactivated.") {

                    // toast.success("Referral section approved successfully. Previous approved section deactivated.")
                    // setTimeout(() => onClose(), 1500)
                    // dispatch(clearTableGetId(null))
                    // dispatch(clearCustomerId(null))

                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.success("Blog section approved successfully. Previous approved section deactivated.")

                        // toast.success("Stake Now section approved successfully. Previous approved section deactivated.")
                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.error(approveContentResponse.payload.message)

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                }
            }
            else if (sectionNameForApproveAndReject === "ContactUsSecttion") {
                const data1 = {
                    data: {},
                    method: "put",
                    apiName: `approveContactUsSection/${TableId}`
                };
                const approveContentResponse = await dispatch(actions.APPROVECONTACTUSSECTION(data1));

                console.log(approveContentResponse.payload.message, "approveCustomerResponse");

                if (approveContentResponse.payload.message === "Contact Us section approved successfully. Previous approved section deactivated.") {

                    // toast.success("Referral section approved successfully. Previous approved section deactivated.")
                    // setTimeout(() => onClose(), 1500)
                    // dispatch(clearTableGetId(null))
                    // dispatch(clearCustomerId(null))

                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.success("Contact Us section approved successfully. Previous approved section deactivated.")

                        // toast.success("Stake Now section approved successfully. Previous approved section deactivated.")
                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()
                    }, 1500)

                    setTimeout(() => {
                        toast.error(approveContentResponse.payload.message)

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))
                    }, 2000)

                }
            }  


        }

    }


    console.log(getPermissionsForAuthUser?.data?.roleName, "getPermissionsForAuthUsergetPermissionsForAuthUser")
    return (
        <div>
            {loading && <FullPageLoader />}

            {!values && (getPermissionsForAuthUser?.data?.roleName === "management" || getPermissionsForAuthUser?.data?.roleName === "superAdmin") && approveStatus !== "approved" && approveStatus !== "rejected" && (
                <Grid mt={1} sx={{ display: "flex", justifyContent: "end" }}>

                    <Stack spacing={2} direction="row">
                        {approveStatus !== "deactivate" && (
                            <Button
                                variant="contained"
                                onClick={handleRejectCommendOpenModal}

                                sx={{
                                    // backgroundColor: "#C38F51",
                                    textTransform: "none",
                                    color: "#F53E5C",
                                    fontSize: "16px",
                                    // padding: "0px 40px",
                                    padding: { xs: "0px 20px", md: "0px 40px" },

                                    minHeight: "40px",
                                    borderRadius: "23px",
                                    boxShadow: "none",
                                    border: "1px solid #F53E5C",
                                    background: "white 0% 0% no-repeat padding-box",
                                    // "&:hover": {
                                    //     backgroundColor: "#3B4056",
                                    // },
                                }}
                            >
                                {/* {bannerDates?.[0]?.additional_data?.[0]?.primary_button_text || "Primary Button"} */}
                                Reject
                            </Button>
                        )}
                        <Button
                            variant="outlined"
                            onClick={() => {
                                contentApprove()
                            }}
                            sx={{
                                // backgroundColor: "#FFAA17",
                                border: "1px solid #1FC45B",
                                textTransform: "none",
                                boxShadow: "none",
                                color: "white",
                                fontSize: "16px",
                                padding: { xs: "0px 20px", md: "0px 40px" },
                                minHeight: "40px",
                                borderRadius: "23px",
                                // font: "normal normal normal 16px / 25px Roboto",
                                letterSpacing: "0px",
                                color: "white",
                                background: "#1FC45B"
                                // "&:hover": {
                                //     backgroundColor: "#C38F51",
                                // },
                            }}
                        >
                            {/* {bannerDates?.[0]?.additional_data?.[0]?.secondary_button_text || "Secondary Button"} */}
                            Approve
                        </Button>
                    </Stack>
                </Grid>
            )}
            <RejectCommendModal
                open={isRejectCommendModalopen}
                onClose={handleRejectCommendCloseModal}
                onPreviewModalClose={onClose}
                sectionNameForApproveAndReject={sectionNameForApproveAndReject}
            />
        </div>
    )
}

export default ModalApproveButton